







import VueOptions from '@utils/VueOptions'
import StepNavigation from './StepNavigation'

settings =
  name: 'StepContainer'

  vue:
    props: ['wizard', 'step']

    components: {
      StepNavigation,
    }

    computed:
      navigation: -> @step.navigation || {}
      hasCustomNavigation: -> @$slots.navigation?

export default VueOptions.vue settings
